'use client';
import { FC, useMemo } from 'react';

import { CMSHowToParticipate } from '@/api/cms/base';
import { ImageComponent } from '@/components/Image';
import {
  getDefaultSection,
  getMatchingSection,
} from '@/helpers/userAccessSection';
import { useCommonStore } from '@/store/commonStore';

import {
  ScHowToParticipateSection,
  ScHowToParticipateSectionCard,
  ScHowToParticipateSectionTitle,
} from './styled';

interface HowToParticipateSectionProps {
  title: string;
  sections: CMSHowToParticipate[];
}

export const HowToParticipateSection: FC<HowToParticipateSectionProps> = ({
  title,
  sections,
}) => {
  const user = useCommonStore.use.user();

  const cards = useMemo(() => {
    const section = getMatchingSection(sections, user);
    return section ? section.cards : getDefaultSection(sections)?.cards;
  }, [sections, user]);

  if (!cards) return null;

  return (
    <ScHowToParticipateSection>
      <ScHowToParticipateSectionTitle>{title}</ScHowToParticipateSectionTitle>
      <div className="cards">
        {cards.map(({ id, title, description, cardImage }) => (
          <ScHowToParticipateSectionCard key={id}>
            <ImageComponent
              className="image"
              src={cardImage.url}
              width={84}
              height={128}
              alt="step card"
            />
            <p className="title">{title}</p>
            <p className="description">{description}</p>
          </ScHowToParticipateSectionCard>
        ))}
      </div>
    </ScHowToParticipateSection>
  );
};
